import { render } from "./EventSinglePage.vue?vue&type=template&id=ed319144&scoped=true"
import script from "./EventSinglePage.vue?vue&type=script&lang=js"
export * from "./EventSinglePage.vue?vue&type=script&lang=js"

import "./EventSinglePage.vue?vue&type=style&index=0&id=ed319144&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed319144"]])

export default __exports__